var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.tooltipContent,"placement":"bottom"}},[_c('el-tag',[_vm._v(_vm._s(_vm.office ? _vm.office.userId : ''))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }